import { render, staticRenderFns } from "./InstructorsTab.vue?vue&type=template&id=83e3a49e&"
import script from "./InstructorsTab.vue?vue&type=script&lang=js&"
export * from "./InstructorsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports